"use client";
import clsx from "clsx";

import { Column } from "@/components/containers";
import { Accordion } from "@/components/displays/Accordion";

import styles from "./ProductAdditionalDetailList.module.scss";

export interface ProductAdditionalDetailListProps {
  rawMaterials?: React.ReactNode;
  allergen?: React.ReactNode;
  allergenLink?: string;
  allergenAnnotation?: string;
}

export function ProductAdditionalDetailList({
  rawMaterials,
  allergen,
  allergenLink,
  allergenAnnotation,
}: ProductAdditionalDetailListProps) {
  return (
    <div className={styles.container}>
      {rawMaterials && (
        <Accordion title="原材料">
          <Column className={styles.accordionBody}>
            <span>{rawMaterials}</span>
          </Column>
        </Accordion>
      )}
      {allergen && (
        <Accordion title="アレルゲン">
          <Column className={styles.accordionBody}>
            <div className={clsx("text__center", styles.allergen)}>
              <p className="text__white text__bold">アレルゲン（28品目対象）</p>
              <p className="text__m text__bold">{allergen}</p>
            </div>
            {allergenAnnotation && (
              <p className={clsx(styles.descriptionText, "text__s text__gray__dark mg__top__s")}>
                {allergenAnnotation}
              </p>
            )}
            {allergenLink && (
              <p className={clsx(styles.descriptionText, "text__s text__gray__dark mg__top__s")}>
                製造工場で使用している原材料については、
                <a href={allergenLink} target="_blank">
                  こちら
                </a>
                をご覧ください。
              </p>
            )}
          </Column>
        </Accordion>
      )}
      <Accordion title="製造所">
        <Column className={styles.accordionBody}>
          <p className={clsx(styles.descriptionText, "text__m")}>
            製造所については、
            <a href="https://basefood.zendesk.com/hc/ja/articles/900001534763" target="_blank">
              こちら
            </a>
            をご覧ください。
          </p>
        </Column>
      </Accordion>
    </div>
  );
}
